import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { loginRequest } from "../authProvider";

export default function useGraphApiToken() {
  const { instance } = useMsal();
  const [graphToken, setGraphToken] = useState<string>();
  useEffect(() => {
    const getToken = async () => {
      const currentAccount = instance.getActiveAccount();
      if (!currentAccount) return;
      const response = await instance.acquireTokenSilent({
        // Request Files.ReadWrite so the token can be used to upload DOCX to
        // OneDrive and download the PDF conversion via Microsoft Graph.
        scopes: ["User.Read", "Files.ReadWrite"],
        account: currentAccount,
      });
      setGraphToken(response.accessToken);
    };

    getToken();
  }, [instance]);
  return graphToken;
}
